import React from "react";
import "./WantListingRail.scss";

const WantListingRail = ({ children }) => (
  <div className="col-12 col-md-5 pe-md-3 col-lg-4 pe-lg-3 col-xl-4 pe-xl-2 want-listing-rail">
    {children}
  </div>
);

export default WantListingRail;
